module.exports = __webpack_public_path__ + "static/media/bg-img-2.b603d8ef.svg";